/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FinancialPlanFundBeforeDto
 */
export interface FinancialPlanFundBeforeDto {
  /**
   *
   * @type {number}
   * @memberof FinancialPlanFundBeforeDto
   */
  balance: number;
  /**
   *
   * @type {number}
   * @memberof FinancialPlanFundBeforeDto
   */
  reserved: number;
  /**
   *
   * @type {number}
   * @memberof FinancialPlanFundBeforeDto
   */
  total: number;
}

export function FinancialPlanFundBeforeDtoFromJSON(json: any): FinancialPlanFundBeforeDto {
  return FinancialPlanFundBeforeDtoFromJSONTyped(json, false);
}

export function FinancialPlanFundBeforeDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FinancialPlanFundBeforeDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    balance: json["balance"],
    reserved: json["reserved"],
    total: json["total"],
  };
}

export function FinancialPlanFundBeforeDtoToJSON(value?: FinancialPlanFundBeforeDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    balance: value.balance,
    reserved: value.reserved,
    total: value.total,
  };
}
